import React, {useState} from 'react';
import DownloadsFilterSearch from "./DownloadsFilterSearch";
import DownloadsFilterTags from "./DownloadsFilterTags";
import DownloadsFilterOptions from "./DownloadsFilterOptions";
import {FilterTags} from "../types/filterTags";
import {FilterDemand} from "../types/filterDemand";

type DownloadsFilterProps = {
    demand : FilterDemand;
    setDemand : (demand: FilterDemand) => void
    searchTerm : string
    setSearchTerm : (value: string) => void
    filterTags : FilterTags[],
    singleTag : string
}

function DownloadsFilter({demand, setDemand, searchTerm, setSearchTerm, filterTags, singleTag} : DownloadsFilterProps) {

    const [showOptions, setShowOptions] = useState<boolean>(false);

    return (
        <div className='downloadsOverview__filter'>
            <DownloadsFilterSearch
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                demand={demand}
                setDemand={setDemand}
            />

            <DownloadsFilterTags
                filterTags={filterTags}
                selectedTag={demand.tags}
                selectTag={(tagId: string) => setDemand({...demand, tags: tagId, limit: 15, option1: 0, option2: 0})}
                showOptions={showOptions}
                setShowOptions={setShowOptions}
                singleTag={singleTag}
            />

            {showOptions &&
                <DownloadsFilterOptions
                    demand={demand}
                    setDemand={setDemand}
                />
            }
        </div>
    );
}

export default DownloadsFilter;
